<div
  class="rounded-lg border dark:border-gray-700 bg-white dark:bg-gray-800 m-2"
>
  <slot />
</div>
